export function getMapAccessApproveLink(userId, mapId) {
  return `/request/${userId}/map/${mapId}`
}
